import { render, staticRenderFns } from "./ChurnReport.vue?vue&type=template&id=25b4d84b&scoped=true"
import script from "./ChurnReport.vue?vue&type=script&lang=ts"
export * from "./ChurnReport.vue?vue&type=script&lang=ts"
import style0 from "./ChurnReport.vue?vue&type=style&index=0&id=25b4d84b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b4d84b",
  null
  
)

export default component.exports